<template>
  <div class="mr-material" :class="{ 'active': material.active }">
    <i :class="`iconfont icon-${material.iconClass}`"></i>
    <p>{{ material.name }}</p>
    <span v-show="!hideBridge" class="add" @click="$toast('请使用电脑登录网站平台进行操作')"></span>
  </div>
</template>

<script>
  export default {
    name: 'MaterialItem',
    props: {
      material: {
        type: Object
      },
      hideBridge: { // 是否显示红色加号
        type: Boolean,
        default: () => false
      }
    }
  }
</script>

<style lang="scss" scoped>
.mr-material{
  position: relative;
  color: #9DA4B3;
  text-align: center;
  .iconfont{
    font-size: 16px;
  }
  &.active{
    color: #0DC268;
    .add{
      display: none;
    }
  }
  .add{
    position: absolute;
    top: 0;
    right: 0;
    transform: translate3d(50%, -60%, 0);
    background-color: #FC3159;
    padding: 0 6px;
    border-radius: 10px;
    color: #fff;
    font-size: 10px;
    white-space: nowrap;
    cursor: pointer;
    &:after{
      display: inline-block;
      margin-bottom: -3px;
      content: "+";
      transform: translateY(-1px)
    }
  }
}
</style>
